
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { networkStatusAtom } from '../AtomStore/store';

const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useAtom(networkStatusAtom);

    useEffect(() => {
        const updateNetworkStatus = () => {
            setIsOnline(navigator.onLine);
        };

        window.addEventListener('online', updateNetworkStatus);
        window.addEventListener('offline', updateNetworkStatus);

        return () => {
            window.removeEventListener('online', updateNetworkStatus);
            window.removeEventListener('offline', updateNetworkStatus);
        };
    }, [setIsOnline]);

    return isOnline;
};

export default useNetworkStatus;
